import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Statement } from "../components/Statement";
import { Manifesto } from "../components/Manifesto";
import { AttarStory } from "../components/AttarStory";

export default function Home({ onNavigate }) {
    return (
        <div data-testid="home-page">
            <Hero onNavigate={onNavigate} />
            <Marquee />
            <Statement />
            <Manifesto />
            <AttarStory />
        </div>
    );
}
